import * as moment from "moment";
import { Component } from "vue-property-decorator";
import { Route } from "vue-router/types/router";
import { CommuneDto } from "../../dto/GenApi.iNotPaie.Dto/CommuneDto";
import { DemandeRecuperationAbsencesFuturesDto } from "../../dto/GenApi.iNotPaie.Dto/DemandeRecuperationAbsencesFuturesDto";
import { DemandeTransfertAbsenceDto } from "../../dto/GenApi.iNotPaie.Dto/DemandeTransfertAbsenceDto";
import { EntreeSalarieDto } from "../../dto/GenApi.iNotPaie.Dto/EntreeSalarieDto";
import { HoraireHebdoDto } from "../../dto/GenApi.iNotPaie.Dto/HoraireHebdoDto";
import { ParametreDto } from "../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { SalarieDto } from "../../dto/GenApi.iNotPaie.Dto/SalarieDto";
import dateHelper from "../../Helper/dateHelper";
import formulaireEntreeSortieHelper from "../../Helper/formulaireEntreeSortieHelper";
import {
    decimalHeuresEnMinutes,
    formatMinutesAsHHmm,
    horairesHebdoSontRenseignes, libelleAffichageHorairesPresence, normaliserHoraireHebdoRecu, totalMinutesHoraireHebdo
} from "../../Helper/horaireHebdoHelper";
import numberHelper from "../../Helper/numberHelper";
import securiteSocialHelper from "../../Helper/securiteSocialHelper";
import stringHelper from "../../Helper/stringHelper";
import Form from "../../shared/components/forms/Form";
import VerticalScroll from "../../shared/components/VerticalScroll/vertical-scroll";
import { InputOption, KeyValue } from "../../shared/models/Input";
import { NotificationServiceInstance } from "../../shared/services/notification.service";
import { EventBus } from "../Controls/EventBus";
import EventConstants, { RoleConstants } from "../Controls/EventConstants";
import { ParametresInstance } from "../Controls/Parameters";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { VueBase } from "../Controls/VueBase";
import { ModalAlerteOptions } from "../modalComponents/modalAlerte/modalAlerte";
import ModalTransfertAbsencesFutures from "../modalComponents/modalTransfertAbsencesFutures/modalTransfertAbsencesFutures";
import { DataForm, dataFormBase, listeReglement, listeSituation } from "./entreeSalarie.model";
import { regimeAideChoixKey } from "./modalRegimeDecision/regimeDecisionEntree.tree";

interface entreesSalarieChargeInfos {
    isModified: boolean;
    dataForm: DataForm;
    readOnly: boolean;
    entreeSalarie: EntreeSalarieDto;
    idSalarie?: number;
    horaireHebdo?: HoraireHebdoDto;
}

@Component({
    components: {
        ModalHoraireHebdo: require("../modalComponents/modalHoraireHebdo/modalHoraireHebdo.vue.html"),
        ModalTransfertAbsencesFutures: require("../modalComponents/modalTransfertAbsencesFutures/modalTransfertAbsencesFutures.vue.html"),
        ModalRegimeDecisionEntreeSalarie: require("./modalRegimeDecision/modalRegimeDecisionEntreeSalarie.vue.html")
    },
    beforeRouteEnter(to: Route, from: Route, next: any) {
        if ((Number(to.params.id) == 0 && !ParametresInstance.userHasRole(RoleConstants.UtilisateurPST)) || (!to.query || to.query.titre == null)) {
            next(false);
            return;
        }

        next(v => {
            const vm = (v as EntreeSalarieComponent);
            vm.Init();
        });
    },
    beforeRouteUpdate(to: Route, from: Route, next: any) {
        if ((Number(to.params.id) == 0 && !ParametresInstance.userHasRole(RoleConstants.UtilisateurPST)) || (!to.query || to.query.titre == null)) {
            next(false);
            return;
        }

        const _this = (this as EntreeSalarieComponent);
        const idSalarie: number | undefined = from.query.idSalarie !== undefined ? Number(from.query.idSalarie) : undefined;
        _this.saveState(Number(from.params.id), idSalarie);
        next();
        _this.Init();
    },
    beforeRouteLeave(to: Route, from: Route, next: any) {
        const _this = (this as EntreeSalarieComponent);
        if (!_this.disableBeforeRouteLeave) {
            const idSalarie: number | undefined = from.query.idSalarie !== undefined ? Number(from.query.idSalarie) : undefined;
            _this.saveState(Number(from.params.id), idSalarie);
        }
        next();
    }
})

export default class EntreeSalarieComponent extends VueBase {
    public scrollFormEntreeSalarie = <VerticalScroll>this.$refs.scrollFormEntreeSalarie;
    public formEntreeSalarie = <Form>this.$refs.formEntreeSalarie;
    public modalTransfertAbsencesFutures?: ModalTransfertAbsencesFutures;
    public showModalHoraireHebdo = false;
    public horaireHebdoPourModale: HoraireHebdoDto | undefined = undefined;
    public libelleHeuresPourModale: string | undefined = undefined;

    public dataReady = false;
    public initData = false;
    public isAdminPst = false;
    public isAdmin = false;
    public isUtilisateurPst = false;
    public readOnly = false;
    public disableBeforeRouteLeave: boolean = false
    public hasHorairesError = false; // Indique si il y a une erreur sur les horaires de présence

    public dataForm: DataForm = this.copy(dataFormBase);
    public listeSituation = listeSituation;
    public listeReglement = listeReglement;

    public listePays: ParametreDto[] = [];
    public listeClassifications: ParametreDto[] = [];
    public listeTypeContrats: ParametreDto[] = [];
    public listeMaladieRetraites: ParametreDto[] = [];
    public listeMaladieRetraitesFiltered: ParametreDto[] = [];
    public listeNatures: ParametreDto[] = [];
    public listeCommune: CommuneDto[] = [];
    public listeMutuelles: ParametreDto[] = [];
    public listeMotifRecours: ParametreDto[] = [];
    public listeTypesMajoration: ParametreDto[] = [];
    public listeSalariesActifs: SalarieDto[] = [];
    public horairesPresenceLibelle: string = "À renseigner";
    public showHorairesPresenceAlerte = false;

    public amountLoading = 0;

    public horaireHebdo: HoraireHebdoDto | undefined = undefined;

    /** Dernier code régime « réel » (hors entrée d'aide) pour restaurer la liste après « M'aider à choisir » */
    private regimeMemoPourAide = "";
    public isManualChoice = false;

    /** Présence de la modal d'aide au régime (montage/démontage comme dashboardConge / modalAjoutConge). */
    public modalRegimeDecisionVisible = false;

    public entreeSalarie?: EntreeSalarieDto = {
        Id: 0,
        DateNaissance: undefined,
        DateEntree: undefined,
        DateEntreeMetier: undefined,
        DateFinPrevisionnelleCDD: undefined,
        DateCreation: new Date(),
        DateModification: new Date(),
        NombreHeuresHebdomadaires: 0,
        SalaireBrutTotal: 0,
        SalaireBrutHoraire: 0,
        NombrePointsComplementaire: 0,
        ComplementSalaire: 0,
        EstValidee: false,
        EstSoumise: false,
        ModeReglement: 1,
        SalarieRemplace: "",
        ContratTravail: 0,
        DeclarationsEmbauches: 0,
        IdSalarieRemplace: 0,
        IbanCP: "",
        IbanCC: "",
        Bic: "",
        Titulaire: "",
        Domiciliation: "",
        NomBanque: ""
    };

    public listIdCharges: number[] = [];
    public currentId = 0;
    public idSalarie?: number = undefined;

    public entreeSalarieChargees: Record<number, entreesSalarieChargeInfos> = {};

    /** Force le remontage du Form à chaque onglet (les champs .sync ne suivent pas un remplacement de dataForm). */
    public get cleFormulaireEntree(): string {
        return `${this.currentId}-${this.idSalarie ?? ""}`;
    }

    public mounted(): void {
        this.dataReady = false;
        this.scrollFormEntreeSalarie = <VerticalScroll>this.$refs.scrollFormEntreeSalarie;
        this.formEntreeSalarie = <Form>this.$refs.formEntreeSalarie;

        EventBus.$on(EventConstants.TAB_CLOSED, e => {
            if (e.path.includes("/entreeSalarie/")) {
                this.removeState(Number(e.params.id));
            }
        });
    }

    public Init(): void {
        this.disableBeforeRouteLeave = false;
        this.dataReady = false;
        this.initData = false;
        this.currentId = Number(this.$route.params.id);
        this.idSalarie = this.$route.query.idSalarie !== undefined ? Number(this.$route.query.idSalarie) : undefined;
        this.hasHorairesError = false;

        const currentSalarieChargee = this.entreeSalarieChargees[this.currentId];

        //Si on a déjà un onglet sur cette Id 
        if (currentSalarieChargee != undefined) {
            //Si un onglet est déjà ouvert mais que c'est pour un autre salarié on doit charger les données pour ce salarié
            //Sinon on recharge l'état de l'onglet
            if (currentSalarieChargee.idSalarie !== this.idSalarie) {
                this.initNewOnglet();
            } else {
                this.dataForm = this.copy(currentSalarieChargee.dataForm);
                this.isModified = currentSalarieChargee.isModified;
                this.readOnly = currentSalarieChargee.readOnly;
                this.entreeSalarie = this.copy(currentSalarieChargee.entreeSalarie);
                this.idSalarie = currentSalarieChargee.idSalarie;
                this.horaireHebdo = currentSalarieChargee.horaireHebdo ? this.copy(currentSalarieChargee.horaireHebdo) : undefined;
                this.majAffichageHorairesPresence();
                this.dataForm.heuresSemaine.error = false;
                this.dataReady = true;
                this.initData = true;
            }
        }
        else {
            this.initNewOnglet();
        }
    }

    public initNewOnglet(): void {
        this.dataForm = this.copy(dataFormBase);
        this.clearEntreeSalarie();
        this.initListes();
    }

    // Permet de sauvegarder l'état de l'onglet pour le recharger si on revient dessus
    public saveState(id: number, idSalarie?: number): void {
        this.entreeSalarieChargees[id] = {
            isModified: this.isModified,
            dataForm: this.copy(this.dataForm),
            readOnly: this.readOnly,
            entreeSalarie: this.copy(this.entreeSalarie),
            idSalarie: idSalarie,
            horaireHebdo: this.horaireHebdo ? this.copy(this.horaireHebdo) : undefined
        };
    }

    // Permet de supprimer une sauvegarde d'état de l'onglet
    public removeState(id: number): void {
        if (this.entreeSalarieChargees[id]) {
            delete this.entreeSalarieChargees[id];
        }
    }

    public initListes(): void {
        this.amountLoading = 10;

        if (ParametresInstance.listeClassifications.length > 0) {
            this.listeClassifications = ParametresInstance.listeClassifications;
            this.amountLoading--;
        } else {
            ServicesFactoryInstance.ParametresService.getClassifications(false, data => {
                this.listeClassifications = data;
                this.amountLoading--;
                this.checkListLoaded();
            });
        }

        ServicesFactoryInstance.ParametresService.getMaladieRetraites(true, data => {
            this.listeMaladieRetraites = data;
            this.setListeMaladieRetraitesFiltrees();

            this.amountLoading--;
            this.checkListLoaded();
        });

        if (ParametresInstance.listePays.length > 0) {
            this.listePays = ParametresInstance.listePays;
            this.amountLoading--;
        } else {
            ServicesFactoryInstance.ParametresService.getPays(data => {
                this.listePays = data;
                this.amountLoading--;
                this.checkListLoaded();
            });
        }

        if (ParametresInstance.allCommune.length > 0) {
            this.listeCommune = ParametresInstance.allCommune;
            this.amountLoading--;
        } else {
            ServicesFactoryInstance.CommunesService.getCommunes("", data => {
                this.listeCommune = data;
                this.amountLoading--;
                this.checkListLoaded();
            });
        }

        if (ParametresInstance.listeTypeContrats.length > 0) {
            this.listeTypeContrats = ParametresInstance.listeTypeContrats.filter(typeContrat => typeContrat.EstVisiblePst);
            this.amountLoading--;
        } else {
            ServicesFactoryInstance.ParametresService.getTypeContrats(data => {
                this.listeTypeContrats = data.filter(typeContrat => typeContrat.EstVisiblePst);
                this.amountLoading--;
                this.checkListLoaded();
            });
        }

        if (ParametresInstance.listeNatureContrats.length > 0) {
            this.listeNatures = ParametresInstance.listeNatureContrats;
            this.amountLoading--;
        } else {
            ServicesFactoryInstance.ParametresService.getNatureContrats(data => {
                this.listeNatures = data;
                this.amountLoading--;
                this.checkListLoaded();
            });
        }

        if (ParametresInstance.listeMutuelles.length > 0) {
            this.listeMutuelles = ParametresInstance.listeMutuelles;
            this.amountLoading--;
        } else {
            ServicesFactoryInstance.ParametresService.getCaisseComplementaires(data => {
                this.listeMutuelles = data;
                this.amountLoading--;
                this.checkListLoaded();
            });
        }

        if (ParametresInstance.listeTypesMajoration.length > 0) {
            this.listeTypesMajoration = ParametresInstance.listeTypesMajoration;
            this.amountLoading--;
        } else {
            ServicesFactoryInstance.ParametresService.getListeTypesMajoration(data => {
                this.listeTypesMajoration = data;
                this.amountLoading--;
                this.checkListLoaded();
            });
        }

        ServicesFactoryInstance.SalarieService.getSalariesActifs(data => {
            this.listeSalariesActifs = data;
            this.amountLoading--;
            this.checkListLoaded();
        });

        ServicesFactoryInstance.ParametresService.getMotifRecours(data => {
            this.listeMotifRecours = data;
            this.amountLoading--;
            this.checkListLoaded();
        });
    }

    public checkListLoaded(): void {
        // Onglet restauré depuis entreeSalarieChargees : ne pas relancer un chargement
        if (this.initData) {
            return;
        }

        if (this.amountLoading === 0) {
            this.resumeForm();
        }
    }

    public resumeForm(): void {
        if (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.Code != undefined && this.entreeSalarie != undefined) {
            this.entreeSalarie.CodeSociete = ParametresInstance.societeCourante.Code;
        }

        this.isAdminPst = ParametresInstance.userHasRole(RoleConstants.AdministrateurPST);
        this.isAdmin = ParametresInstance.userHasRole(RoleConstants.Administrateur);
        this.isUtilisateurPst = ParametresInstance.userHasRole(RoleConstants.UtilisateurPST);

        this.initEntreeSalarie();
    }

    public initEntreeSalarie(): void {
        if (!this.initData) {
            this.horaireHebdo = undefined;
            this.majAffichageHorairesPresence();
            this.initData = true;

            if (this.idSalarie !== undefined && this.$route.params.id === "0") { // Ajout par id
                this.loadDataEntreeSalarieExist();
            } else if (this.idSalarie === undefined && this.$route.params.id !== "0") { // Modification
                this.loadDataEntreeSalarie();
            } else {
                this.resetForm();
            }
        }
    }

    public loadDataEntreeSalarieExist(): void {
        const routeId = Number(this.$route.params.id);

        ServicesFactoryInstance.EntreeSalarieService.getEntreeSalarieFromFicheSalarie(Number(this.idSalarie), data => {
            if (Number(this.$route.params.id) !== routeId) {
                return;
            }
            this.chargeEntreeSalarie(data);
        });
    }

    public loadDataEntreeSalarie(): void {
        const routeId = Number(this.$route.params.id);

        ServicesFactoryInstance.EntreeSalarieService.getEntreeSalarie(routeId, data => {
            if (Number(this.$route.params.id) !== routeId) {
                return;
            }
            this.chargeEntreeSalarie(data);
        });
    }

    public chargeEntreeSalarie(data: EntreeSalarieDto): void {
        this.entreeSalarie = data;
        this.setReadOnly();

        if (this.readOnly) {
            for (const data in this.dataForm) {
                this.dataForm[data].disabled = true;
            }
        } else {
            for (const data in this.dataForm) {
                this.dataForm[data].disabled = false;
            }
            //Mettre en lecture certains champs pour les utilisateurs PST si on a récupéré les informations d'un salarié
            if (data.IdSalarieOrigine != undefined && this.isUtilisateurPst && !this.isAdmin && !this.isAdminPst) {
                this.makeInputReaddOnly(this.dataForm.civilite);
                this.makeInputReaddOnly(this.dataForm.nomNaissance);
                this.makeInputReaddOnly(this.dataForm.dateNaissance);
                this.makeInputReaddOnly(this.dataForm.communeNaissance);
                this.makeInputReaddOnly(this.dataForm.pays);
                this.makeInputReaddOnly(this.dataForm.nationalite);
                this.makeInputReaddOnly(this.dataForm.secu);
                this.makeInputReaddOnly(this.dataForm.nom);
                this.makeInputReaddOnly(this.dataForm.prenom);
            }
        }

        if (this.entreeSalarie !== undefined) {
            this.dataForm.civilite.vmodel = this.entreeSalarie.Civilite ? this.entreeSalarie.Civilite : "";
            this.dataForm.nom.vmodel = this.entreeSalarie.Nom ? this.entreeSalarie.Nom : "";
            this.dataForm.prenom.vmodel = this.entreeSalarie.Prenom ? this.entreeSalarie.Prenom : "";
            this.dataForm.nomNaissance.vmodel = this.entreeSalarie.NomNaissance ? this.entreeSalarie.NomNaissance : "";
            this.dataForm.dateNaissance.vmodel = this.entreeSalarie.DateNaissance ? moment(this.entreeSalarie.DateNaissance).format("YYYY-MM-DD") : "";
            this.dataForm.communeNaissance.vmodel = this.entreeSalarie.VilleNaissance ? this.entreeSalarie.VilleNaissance : "";
            this.dataForm.pays.vmodel = this.entreeSalarie.PaysNaissance ? this.entreeSalarie.PaysNaissance : "";
            this.dataForm.nationalite.vmodel = this.entreeSalarie.Nationalite ? this.entreeSalarie.Nationalite : "";
            this.dataForm.situation.vmodel = this.entreeSalarie.SituationFamiliale ? this.entreeSalarie.SituationFamiliale : "";
            this.dataForm.adresse.vmodel = this.entreeSalarie.Adresse ? this.entreeSalarie.Adresse : "";
            this.dataForm.complement.vmodel = this.entreeSalarie.Complement ? this.entreeSalarie.Complement : "";
            this.dataForm.codepostal.vmodel = this.entreeSalarie.CodePostal ? this.entreeSalarie.CodePostal : "";
            this.dataForm.commune.vmodel = this.entreeSalarie.Ville ? this.entreeSalarie.Ville : "";
            this.dataForm.secu.vmodel = this.entreeSalarie.NumeroSECU ? securiteSocialHelper.formatNumeroSecuriteSocial(this.entreeSalarie.NumeroSECU) : "";
            this.dataForm.crpcen.vmodel = this.entreeSalarie.Crpcen ? this.entreeSalarie.Crpcen.toString() : "";

            this.dataForm.telephoneFixe.vmodel = this.entreeSalarie.TelFixe ? this.entreeSalarie.TelFixe : "";
            this.dataForm.telephonePortable.vmodel = this.entreeSalarie.TelPortable ? this.entreeSalarie.TelPortable : "";
            this.dataForm.emailPerso.vmodel = this.entreeSalarie.MailPerso ? this.entreeSalarie.MailPerso : "";
            this.dataForm.emailPro.vmodel = this.entreeSalarie.MailPro ? this.entreeSalarie.MailPro : "";

            this.dataForm.mutuelle.vmodel = this.entreeSalarie.Mutuelle ? this.entreeSalarie.Mutuelle : "";
            this.dataForm.transport.vmodel = stringHelper.convertNumberOrUndefinedToString(this.entreeSalarie.RemboursementTransport);
            this.dataForm.titreRestaurant.vmodel = stringHelper.convertNumberOrUndefinedToString(this.entreeSalarie.TitresRestaurant);
            this.dataForm.modeReglement.vmodel = this.entreeSalarie.ModeReglement ? this.entreeSalarie.ModeReglement.toString() : "";

            this.dataForm.classification.vmodel = this.entreeSalarie.Classification ? this.entreeSalarie.Classification : "";
            this.dataForm.intitule.vmodel = this.entreeSalarie.Poste ? this.entreeSalarie.Poste : "";
            this.dataForm.dateEntree.vmodel = this.entreeSalarie.DateEntree ? moment(this.entreeSalarie.DateEntree).format("YYYY-MM-DD") : "";
            this.dataForm.dateEntreeMetier.vmodel = this.entreeSalarie.DateEntreeMetier ? moment(this.entreeSalarie.DateEntreeMetier).format("YYYY-MM-DD") : "";
            this.dataForm.heuresSemaine.vmodel = stringHelper.convertNumberOrUndefinedToString(this.entreeSalarie.NombreHeuresHebdomadaires);
            this.dataForm.heuresSupSemaine.vmodel = stringHelper.convertNumberOrUndefinedToString(this.entreeSalarie.NombreHeuresSupHebdomadaires);
            this.dataForm.heuresMois.vmodel = stringHelper.convertNumberOrUndefinedToString(this.entreeSalarie.NombreHeuresMensuelles);
            this.dataForm.heuresSupMois.vmodel = stringHelper.convertNumberOrUndefinedToString(this.entreeSalarie.NombreHeuresSupMensuelles);
            this.dataForm.typeMajoration.vmodel = stringHelper.convertNumberOrUndefinedToString(this.entreeSalarie.TypeMajoration);
            this.dataForm.salaire.vmodel = stringHelper.convertNumberOrUndefinedToString(this.entreeSalarie.SalaireBrutTotal);
            this.dataForm.nombrePoint.vmodel = stringHelper.convertNumberOrUndefinedToString(this.entreeSalarie.NombrePointsComplementaire);
            this.dataForm.complementSalaire.vmodel = stringHelper.convertNumberOrUndefinedToString(this.entreeSalarie.ComplementSalaire);
            this.dataForm.nature.vmodel = this.entreeSalarie.NatureContrat ? this.entreeSalarie.NatureContrat : "";
            this.dataForm.type.vmodel = this.entreeSalarie.TypeContrat ? this.entreeSalarie.TypeContrat : "";
            this.dataForm.regime.vmodel = this.entreeSalarie.RegimeMaladieRetraite ? this.entreeSalarie.RegimeMaladieRetraite : "";
            this.regimeMemoPourAide = this.dataForm.regime.vmodel ? this.dataForm.regime.vmodel : "";

            this.dataForm.divers.vmodel = this.entreeSalarie.AutresInformations ? this.entreeSalarie.AutresInformations : "";

            this.dataForm.cp.vmodel = this.entreeSalarie.IbanCP ? this.entreeSalarie.IbanCP : "";
            this.dataForm.cc.vmodel = this.entreeSalarie.IbanCC ? this.entreeSalarie.IbanCC : "";
            this.dataForm.bban.vmodel = this.entreeSalarie.Bban ? this.entreeSalarie.Bban : "";
            this.dataForm.bic.vmodel = this.entreeSalarie.Bic ? this.entreeSalarie.Bic : "";
            this.dataForm.titulaire.vmodel = this.entreeSalarie.Titulaire ? this.entreeSalarie.Titulaire : "";
            this.dataForm.domiciliation.vmodel = this.entreeSalarie.Domiciliation ? this.entreeSalarie.Domiciliation : "";
            this.dataForm.nomBanque.vmodel = this.entreeSalarie.NomBanque ? this.entreeSalarie.NomBanque : "";

            this.dataForm.dateFinCdd.vmodel = this.entreeSalarie.DateFinPrevisionnelleCDD ? moment(this.entreeSalarie.DateFinPrevisionnelleCDD).format("YYYY-MM-DD") : "";
            this.dataForm.motifRecours.vmodel = this.entreeSalarie.CodeMotifRecours ? this.entreeSalarie.CodeMotifRecours : "";
            this.dataForm.salarieRemplace.vmodel = this.entreeSalarie.IdSalarieRemplace ? this.entreeSalarie.IdSalarieRemplace.toString() : "";

            this.toggleRib();
            this.toggleNature();
            this.toggleRemplace();
            this.toggleTypeMajoration();

            // Si l'entrée a un horaire hebdomadaire, on récupère les horaires de présence
            const entreeId = this.entreeSalarie.Id;
            if (this.entreeSalarie.IdHoraireHebdo != null && this.entreeSalarie.Id !== 0) {
                ServicesFactoryInstance.HoraireHebdoService.getHoraireHebdoEntreeSalarie(this.entreeSalarie.Id, horaireData => {
                    if (this.entreeSalarie?.Id !== entreeId) {
                        return;
                    }
                    this.horaireHebdo = horaireData ? normaliserHoraireHebdoRecu(horaireData) : undefined;
                    this.majAffichageHorairesPresence();
                });
            } else {
                this.majAffichageHorairesPresence();
            }

            this.isModified = false;
            this.dataReady = true;


            this.formEntreeSalarie = <Form>this.$refs.formEntreeSalarie;
            this.formEntreeSalarie.resetState();

        }
    }

    public changed(type?: string): void {
        this.isModified = true;

        if (type !== undefined) {
            switch (type) {
                case "heuresSemaine":
                    this.onNbrHeureChanged();
                    break;
                case "heuresSupSemaine":
                    this.onNbrHeureSupChanged();
                    break;
                case "secu":
                    this.updateSecuritySocialNumber();
                    break;
                case "rib":
                    this.toggleRib();
                    break;
                case "nature":
                    this.toggleNature();
                    break;
                case "remplace":
                    this.toggleRemplace();
                    break;
            }
        }
    }

    public toggleNature(): void {
        if (this.dataForm.nature.vmodel === "CDD") {
            this.dataForm.dateFinCdd.disabled = this.readOnly;
            this.dataForm.motifRecours.disabled = this.readOnly;
            this.toggleRemplace();
        } else {
            this.dataForm.dateFinCdd.disabled = true;
            this.dataForm.motifRecours.disabled = true;
            this.dataForm.salarieRemplace.disabled = true;
        }
    }

    public toggleRemplace(): void {
        if (this.dataForm.motifRecours.vmodel === "REMP") {
            this.dataForm.salarieRemplace.disabled = this.readOnly;
        } else {
            this.dataForm.salarieRemplace.disabled = true;
        }
    }

    public toggleRib(): void {
        if (this.dataForm.modeReglement.vmodel === "3") {
            this.dataForm.divers.height = 114;

            this.dataForm.cp.disabled = this.readOnly;
            this.dataForm.cc.disabled = this.readOnly;
            this.dataForm.bban.disabled = this.readOnly;
            this.dataForm.bic.disabled = this.readOnly;
            this.dataForm.titulaire.disabled = this.readOnly;
            this.dataForm.domiciliation.disabled = this.readOnly;
            this.dataForm.nomBanque.disabled = this.readOnly;

            if (this.dataForm.titulaire.vmodel === "") {
                let titulaire = "";

                if (this.dataForm.civilite.vmodel) {
                    titulaire += this.dataForm.civilite.vmodel + " ";
                }

                if (this.dataForm.nom.vmodel) {
                    titulaire += this.dataForm.nom.vmodel + " ";
                }

                if (this.dataForm.prenom.vmodel) {
                    titulaire += this.dataForm.prenom.vmodel;
                }

                this.dataForm.titulaire.display = titulaire;
                this.dataForm.titulaire.vmodel = titulaire;
            }
        } else {
            this.dataForm.divers.height = 229;

            this.dataForm.cp.disabled = true;
            this.dataForm.cc.disabled = true;
            this.dataForm.bban.disabled = true;
            this.dataForm.bic.disabled = true;
            this.dataForm.titulaire.disabled = true;
            this.dataForm.domiciliation.disabled = true;
            this.dataForm.nomBanque.disabled = true;

            this.dataForm.titulaire.display = "";
            this.dataForm.titulaire.vmodel = "";
        }
    }

    /**
     * @description Transforme la liste des motifs de recours en une liste de KeyValue
     * @returns Liste de KeyValue
     */
    public get transformListMotifRecours(): KeyValue[] {
        if (!this.listeMotifRecours?.length) {
            return [];
        }

        // Si pas d'entreeSalarie → liste complète (pas de filtre sur EstArchive)
        const listeFiltered = this.entreeSalarie
            ? this.listeMotifRecours.filter(m => !m.EstArchive || m.Code === this.entreeSalarie!.CodeMotifRecours)
            : this.listeMotifRecours;

        return listeFiltered.map(m => ({
            key: m.Code!,
            value: m.Libelle!
        }));
    }

    public transformList(list: ParametreDto[]): KeyValue[] {
        const finalList: KeyValue[] = [];

        for (let i = 0; i < list.length; i++) {
            finalList.push({
                key: list[i].Code!,
                value: list[i].Libelle!
            });
        }

        return finalList;
    }

    /**
     * Liste des régimes avec l'entrée « M'aider à choisir » en tête (icône via CSS sur le conteneur, cf. entreeSalarie.scss).
     */
    public get listeOptionsRegimeAvecAide(): KeyValue[] {
        const currentCode = this.dataForm.regime.vmodel;
        const filtered = this.listeMaladieRetraites.filter(r => !r.EstArchive || r.Code === currentCode);

        const aide: KeyValue = {
            key: regimeAideChoixKey,
            value: "M'aider à choisir"
        };

        return [
            aide,
            ...filtered.map(r => ({
                key: r.Code!,
                value: r.EstArchive ? r.Libelle! + ' (obsolète)' : r.Libelle!
            }))
        ];
    }

    public transformListCommune(list: CommuneDto[]): KeyValue[] {
        const finalList: KeyValue[] = [];

        for (let i = 0; i < list.length; i++) {
            finalList.push({
                key: list[i].CodeInsee!,
                value: list[i].Libelle!
            });
        }

        return finalList;
    }

    public transformListCommuneFull(list: CommuneDto[]): KeyValue[] {
        const finalList: KeyValue[] = [];

        for (let i = 0; i < list.length; i++) {
            finalList.push({
                key: list[i].LibelleCodePostale!,
                value: list[i].LibelleCodePostale!
            });
        }

        return finalList;
    }

    public transformListSalarie(list: SalarieDto[]): KeyValue[] {
        const finalList: KeyValue[] = [];

        for (let i = 0; i < list.length; i++) {
            finalList.push({
                key: list[i].Id.toString()!,
                value: list[i].FullName!
            });
        }

        return finalList;
    }

    public cancelButton(): void {
        if (this.isModified) {
            const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
                message: "Souhaitez-vous vraiment annuler ? Les modifications non sauvegardées seront perdues !",
                callBackYes: (): void => {
                    this.afterSend(false, false);
                }
            });
            EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
        } else {
            this.afterSend(false, false);
        }
    }

    /**
     * @description Lance le workflow pour soumettre le formulaire à la PST
     */
    public submitButton(): void {
        if (!this.isValidNumeroSecu()) return;
        if (!this.isValidHorairesPresence()) return;
        if (this.isRegimeObsolete(true)) return;

        this.soumettre();
    }

    /**
     * @description lance le workflow de sauvegarde du formulaire
     */
    public saveButton(): void {
        if (!this.isValidNumeroSecu()) return;
        if (!this.isValidHorairesPresence()) return;
        if (this.isRegimeObsolete(true)) return;

        this.enregistrer();
    }

    /**
     * Permet de déterminer si le régime maladie / retraite sélectionné est obsolète
     * @param sendNotification Affiche une notification d'erreur si obsolète
     * @returns
     */
    private isRegimeObsolete(sendNotification?: boolean): boolean {
        const code = this.dataForm.regime.vmodel;
        const regime = this.listeMaladieRetraites.find(r => r.Code === code);
        const isArchive = regime?.EstArchive === true;

        if (sendNotification === true && isArchive)
            NotificationServiceInstance.SendFailed("Le régime maladie/retraite sélectionné est obsolète et ne peut plus être utilisé. Veuillez sélectionner un autre régime.");

        return isArchive;
    }

    private setListeMaladieRetraitesFiltrees(): void {
        this.listeMaladieRetraitesFiltered = this.listeMaladieRetraites.filter(
            r => !r.EstArchive || r.Code === this.dataForm.regime.vmodel
        );
    }

    // Permet de set les données du formulaire dans l'entité qui sera sauvegardé en base
    public setFormDataToEntreeSalarie(): void {
        if (this.entreeSalarie !== undefined) {
            this.entreeSalarie.Id = this.currentId;
            this.entreeSalarie.Civilite = this.dataForm.civilite.vmodel;
            this.entreeSalarie.Nom = this.dataForm.nom.vmodel;
            this.entreeSalarie.Prenom = this.dataForm.prenom.vmodel;
            this.entreeSalarie.NomNaissance = this.dataForm.nomNaissance.vmodel;
            this.entreeSalarie.DateNaissance = moment.utc(this.dataForm.dateNaissance.vmodel).toDate();
            this.entreeSalarie.VilleNaissance = this.dataForm.communeNaissance.vmodel;
            this.entreeSalarie.PaysNaissance = this.dataForm.pays.vmodel;
            this.entreeSalarie.Nationalite = this.dataForm.nationalite.vmodel;
            this.entreeSalarie.SituationFamiliale = this.dataForm.situation.vmodel;
            this.entreeSalarie.Adresse = this.dataForm.adresse.vmodel;
            this.entreeSalarie.Complement = this.dataForm.complement.vmodel;
            this.entreeSalarie.CodePostal = this.dataForm.codepostal.vmodel;
            this.entreeSalarie.Ville = this.dataForm.commune.vmodel;
            this.entreeSalarie.NumeroSECU = this.dataForm.secu.vmodel.replace(/ /gi, "");
            this.entreeSalarie.Crpcen = numberHelper.convertToNumberOrUndefined(this.dataForm.crpcen.vmodel);

            this.entreeSalarie.TelFixe = this.dataForm.telephoneFixe.vmodel;
            this.entreeSalarie.TelPortable = this.dataForm.telephonePortable.vmodel;
            this.entreeSalarie.MailPerso = this.dataForm.emailPerso.vmodel;
            this.entreeSalarie.MailPro = this.dataForm.emailPro.vmodel;

            this.entreeSalarie.Mutuelle = this.dataForm.mutuelle.vmodel;
            this.entreeSalarie.RemboursementTransport = numberHelper.convertToNumberOrUndefined(this.dataForm.transport.vmodel);
            this.entreeSalarie.TitresRestaurant = numberHelper.convertToNumberOrUndefined(this.dataForm.titreRestaurant.vmodel);
            this.entreeSalarie.ModeReglement = Number(this.dataForm.modeReglement.vmodel);

            this.entreeSalarie.Classification = this.dataForm.classification.vmodel;
            this.entreeSalarie.Poste = this.dataForm.intitule.vmodel;
            this.entreeSalarie.DateEntree = moment.utc(this.dataForm.dateEntree.vmodel).toDate();
            this.entreeSalarie.DateEntreeMetier = moment.utc(this.dataForm.dateEntreeMetier.vmodel).toDate();
            this.entreeSalarie.NombreHeuresHebdomadaires = numberHelper.convertToNumberOrUndefined(this.dataForm.heuresSemaine.vmodel);
            this.entreeSalarie.NombreHeuresSupHebdomadaires = numberHelper.convertToNumberOrUndefined(this.dataForm.heuresSupSemaine.vmodel);
            this.entreeSalarie.NombreHeuresMensuelles = numberHelper.convertToNumberOrUndefined(this.dataForm.heuresMois.vmodel);
            this.entreeSalarie.NombreHeuresSupMensuelles = numberHelper.convertToNumberOrUndefined(this.dataForm.heuresSupMois.vmodel);
            this.entreeSalarie.TypeMajoration = numberHelper.convertToNumberOrUndefined(this.dataForm.typeMajoration.vmodel);
            this.entreeSalarie.SalaireBrutTotal = numberHelper.convertToNumberOrUndefined(this.dataForm.salaire.vmodel);
            this.entreeSalarie.NombrePointsComplementaire = numberHelper.convertToNumberOrUndefined(this.dataForm.nombrePoint.vmodel);
            this.entreeSalarie.ComplementSalaire = numberHelper.convertToNumberOrUndefined(this.dataForm.complementSalaire.vmodel);

            this.entreeSalarie.NatureContrat = this.dataForm.nature.vmodel;
            this.entreeSalarie.TypeContrat = this.dataForm.type.vmodel;
            this.entreeSalarie.RegimeMaladieRetraite = this.dataForm.regime.vmodel;

            this.entreeSalarie.AutresInformations = this.dataForm.divers.vmodel;

            this.entreeSalarie.IbanCP = this.dataForm.cp.vmodel;
            this.entreeSalarie.IbanCC = this.dataForm.cc.vmodel;
            this.entreeSalarie.Bban = this.dataForm.bban.vmodel;
            this.entreeSalarie.Bic = this.dataForm.bic.vmodel;
            this.entreeSalarie.Titulaire = this.dataForm.titulaire.vmodel;
            this.entreeSalarie.Domiciliation = this.dataForm.domiciliation.vmodel;
            this.entreeSalarie.NomBanque = this.dataForm.nomBanque.vmodel;

            this.entreeSalarie.DateFinPrevisionnelleCDD = moment.utc(this.dataForm.dateFinCdd.vmodel).toDate();
            this.entreeSalarie.CodeMotifRecours = this.dataForm.motifRecours.vmodel;
            this.entreeSalarie.IdSalarieRemplace = Number(this.dataForm.salarieRemplace.vmodel);
        }
    }

    public resetForm(): void {
        this.formEntreeSalarie = <Form>this.$refs.formEntreeSalarie;
        this.formEntreeSalarie.resetState();
        this.formEntreeSalarie.clear();

        if (this.entreeSalarie !== undefined) {
            this.entreeSalarie.ContratTravail = 0;
            this.entreeSalarie.DeclarationsEmbauches = 0;
        }

        this.setReadOnly();
        this.isModified = false;
        this.dataReady = true;
    }


    /**
     * @description Lance le workflow de validation du formulaire pour créer la fiche du salarié
     */
    public validate(): boolean | void {
        if (!this.isValidNumeroSecu()) return;
        if (!this.isValidHorairesPresence()) return;
        if (this.isRegimeObsolete(true)) return false;

        this.validateForm();
    }

    /**
     * @description Validation du formulaire d'entrée du salarié
     */
    public validateEmploye(): void {
        ServicesFactoryInstance.EntreeSalarieService.valideEmployeEntry(this.currentId, data => {

            let titreOnglet = "Entrée ";
            if (this.entreeSalarie !== undefined && this.entreeSalarie.NumeroSECU !== undefined) {
                titreOnglet += this.entreeSalarie.Nom + " " + this.entreeSalarie.Prenom;
            }

            if (data != undefined) {
                ServicesFactoryInstance.SalarieService.GetLastContrat(data, lastContrat => {

                    if (lastContrat != undefined && lastContrat != null)
                        this.openModalTransfertAbsences(data, lastContrat.IdContrat!, titreOnglet);
                    else
                        this.openFicheSalarie(data, titreOnglet)

                }, () => this.openFicheSalarie(data, titreOnglet));
            } else {
                this.openFicheSalarie(data, titreOnglet);
            }

        }, () => this.dataReady = true);

    }

    public updateSecuritySocialNumber(): void {
        const numSecuFinal = securiteSocialHelper.setSecuSocialMandatory(
            this.dataForm.secu.vmodel,
            this.dataForm.civilite.vmodel,
            this.dataForm.dateNaissance.vmodel,
            this.getCommuneNaissance(),
            this.getPaysNaissance()
        );

        this.formatNumeroSecuriteSocial(numSecuFinal);
    }

    /**
     * @description Evenement onBlur du champ numéro de sécurité sociale
     */
    public onBlurNumeroSecuriteSocial(): void {
        this.formatNumeroSecuriteSocial(this.dataForm.secu.vmodel);
        this.isModified = true;
    }

    /**
     * @description Permet de formater le numéro de sécurité sociale
     */
    public formatNumeroSecuriteSocial(numero: string): void {
        numero = numero.replace(/ /gi, "");
        const numeroSecuFormated = securiteSocialHelper.formatNumeroSecuriteSocial(numero);
        this.dataForm.secu.display = numeroSecuFormated;
        this.dataForm.secu.vmodel = numeroSecuFormated;
    }



    public getCommuneNaissance(): CommuneDto | undefined {
        let commune: CommuneDto | undefined;
        let communes = this.listeCommune.filter(commune => commune.LibelleCodePostale === this.dataForm.communeNaissance.vmodel);
        //Si on ne trouve pas par le libelle + code postal, on cherche par le libelle
        if (communes.length === 0) {
            communes = this.listeCommune.filter(commune => commune.Libelle === this.dataForm.communeNaissance.vmodel);
        }

        if (communes.length > 0) {
            commune = communes[0];
        }
        return commune;
    }

    public getPaysNaissance(): ParametreDto | null {
        return this.listePays.filter(pays => pays.Code === this.dataForm.pays.vmodel)[0];
    }

    public onDataChanged(): void {
        this.isModified = true;
    }

    public submit(): void {
        const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
            message: "Souhaitez-vous vraiment soumettre cette entrée à validation ? Vous ne pourrez plus effectuer de changement !",
            callBackYes: (): void => {
                this.dataReady = false;

                this.setFormDataToEntreeSalarie();

                if (this.entreeSalarie !== undefined) {

                    if (this.entreeSalarie.Id === 0) { // Un Ajout
                        ServicesFactoryInstance.EntreeSalarieService.addEntreeSalarie(this.entreeSalarie, data => {
                            if (this.entreeSalarie !== undefined) {
                                this.entreeSalarie.Id = data.Id;
                                this.currentId = data.Id;
                            }
                            this.saveHoraireHebdo();
                            this.soumettreAValidation();

                        }, () => this.dataReady = true);
                    } else { // Une modification

                        ServicesFactoryInstance.EntreeSalarieService.updateEntreeSalarie(this.entreeSalarie, () => {
                            this.saveHoraireHebdo();

                            this.soumettreAValidation();

                        }, () => this.dataReady = true);
                    }
                }
            }
        });
        EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
    }

    public soumettreAValidation(): void {
        ServicesFactoryInstance.EntreeSalarieService.soumettreAValidation(this.currentId, () => {
            NotificationServiceInstance.SendSuccess("L'entrée a été envoyée avec succès.");
            EventBus.$emit(EventConstants.CLOSE_TAB, { path: this.$router.currentRoute.path });
        }, () => this.dataReady = true);
    }

    public onNbrHeureChanged(): void {
        this.dataForm.heuresMois.vmodel = this.dataForm.heuresSemaine.vmodel ? this.calculHeureHebdoParMois(Number(this.dataForm.heuresSemaine.vmodel)).toString() : "";
        this.$nextTick(() => {
            this.validateHorairesPresence();
        });
    }

    public onNbrHeureSupChanged(): void {
        this.dataForm.heuresSupMois.vmodel = this.dataForm.heuresSupSemaine.vmodel ? this.calculHeureHebdoParMois(Number(this.dataForm.heuresSupSemaine.vmodel)).toString() : "";
        this.toggleTypeMajoration();
    }

    public onHoraireHebdoUpdated(horairesHebdoUpdated: HoraireHebdoDto): void {
        if (horairesHebdoUpdated !== null) {
            this.horaireHebdo = normaliserHoraireHebdoRecu(horairesHebdoUpdated);
        }
        this.majAffichageHorairesPresence();
        const horairesErrors = this.validateHorairesPresence();
        if (horairesErrors.length > 0) {
            NotificationServiceInstance.SendWarningList(horairesErrors);
        }
        this.onDataChanged();
    }

    /**
     * @description Ouvre le modal pour modifier les horaires de présence
     */
    public openHoraireHebdo(): void {
        const heuresParSemaine = this.isTempsPartiel ? this.dataForm.heuresSemaine.vmodel : undefined;
        this.libelleHeuresPourModale = heuresParSemaine !== undefined
            ? dateHelper.formatHeuresDecimales(heuresParSemaine.toString())
            : undefined;

        if (this.entreeSalarie?.IdHoraireHebdo !== null && this.horaireHebdo === undefined && this.entreeSalarie?.Id !== 0) {
            const entreeId = this.entreeSalarie!.Id;

            ServicesFactoryInstance.HoraireHebdoService.getHoraireHebdoEntreeSalarie(this.entreeSalarie!.Id, data => {
                if (this.entreeSalarie?.Id !== entreeId) {
                    return;
                }
                const horaireCharge = data ? normaliserHoraireHebdoRecu(data) : undefined;
                this.horaireHebdoPourModale = horaireCharge;
                if (this.horaireHebdo === undefined) {
                    this.horaireHebdo = horaireCharge;
                }
                this.majAffichageHorairesPresence();
                this.showModalHoraireHebdo = true;
            });
        } else {
            this.horaireHebdoPourModale = this.horaireHebdo;
            this.showModalHoraireHebdo = true;
        }
    }

    /**
     * @description Vérifie si le contrat est à temps partiel
     * @returns
     */
    public get isTempsPartiel(): boolean {
        const heures = Number(this.dataForm.heuresSemaine.vmodel);
        return this.dataForm.heuresSemaine.vmodel !== "" && !isNaN(heures) && heures < 35;
    }

    public get horairesPresenceRenseignes(): boolean {
        return horairesHebdoSontRenseignes(this.horaireHebdo);
    }

    /**
     * Met à jour le libellé du champ et l'état d'alerte (propriétés réactives, pas de computed).
     */
    private majAffichageHorairesPresence(): void {
        this.horairesPresenceLibelle = libelleAffichageHorairesPresence(this.horaireHebdo);
        this.showHorairesPresenceAlerte = this.isTempsPartiel && !horairesHebdoSontRenseignes(this.horaireHebdo);
    }

    private appliquerErreurHorairesPresence(enErreur: boolean): void {
        this.hasHorairesError = enErreur;
    }

    /**
     * @description Vérifie si les horaires de présence sont valides et retourne les messages d'erreur.
     * @returns Liste des messages d'erreur (hasHorairesError + erreur visuelle heures/semaine si échec).
     */
    public validateHorairesPresence(): string[] {
        this.majAffichageHorairesPresence();

        if (!this.isTempsPartiel) {
            this.appliquerErreurHorairesPresence(false);
            return [];
        }

        const errors: string[] = [];

        if (!horairesHebdoSontRenseignes(this.horaireHebdo)) {
            errors.push("Les horaires de présence sont obligatoires pour ce contrat.");
        } else {
            const totalMinutes = totalMinutesHoraireHebdo(this.horaireHebdo);
            const cibleMinutes = decimalHeuresEnMinutes(Number(this.dataForm.heuresSemaine.vmodel));

            if (totalMinutes !== cibleMinutes) {
                errors.push(
                    `Le total des horaires de présence (${formatMinutesAsHHmm(totalMinutes)}) doit correspondre aux heures par semaine (${formatMinutesAsHHmm(cibleMinutes)}).`
                );
            }
        }

        this.appliquerErreurHorairesPresence(errors.length > 0);

        return errors;
    }

    // On peut valider une entrée si état = A valider
    public canValider(): boolean {
        return formulaireEntreeSortieHelper.canValider(this.entreeSalarie != undefined ? this.entreeSalarie.EstSoumise : false, this.entreeSalarie != undefined ? this.entreeSalarie.EstValidee : false)
    }

    // On peut soumettre une entrée si état = en cours
    public canSoumettre(): boolean {
        return formulaireEntreeSortieHelper.canSoumettre(this.entreeSalarie != undefined ? this.entreeSalarie.EstSoumise : false, this.entreeSalarie != undefined ? this.entreeSalarie.EstValidee : false)
    }

    /**
     * @description Vérifie si le numéro de sécurité sociale est valide
     * @returns
     */
    public isValidNumeroSecu(): boolean {
        const listError = securiteSocialHelper.isValidSecuSocial(this.dataForm.secu.vmodel);

        if (listError.length > 0) {
            NotificationServiceInstance.SendFailedList(listError);

            return false;
        }

        return true;
    }

    /**
     * Si le régime est vide : intercepter pointerdown en capture (avant focus / mousedown sur l'input),
     * sinon le SelectForm ouvre la liste au focus — le click seul arrive trop tard.
     */
    public onRegimeSelectPointerCapture(ev: PointerEvent): void {
        if (this.readOnly || this.isManualChoice) {
            return;
        }
        // Si le régime est vide, on ouvre la modal de décision
        if (this.dataForm.regime.vmodel == null || this.dataForm.regime.vmodel === "") {
            ev.preventDefault();
            ev.stopPropagation();

            this.modalRegimeDecisionVisible = true;
        }
    }

    /**
     * Sélection dans la liste : entrée d'aide ou régime normal.
     */
    public onRegimeFieldChanged(): void {
        // Si le régime est l'entrée d'aide, on ouvre la modal de décision
        if (this.dataForm.regime.vmodel === regimeAideChoixKey) {
            const restore = this.regimeMemoPourAide;

            this.modalRegimeDecisionVisible = true;

            // Restaurer le régime sélectionné
            this.dataForm.regime.vmodel = restore;
            // Restaurer le libellé du régime sélectionné
            const opt = this.listeOptionsRegimeAvecAide.find(o => o.key === restore);
            this.dataForm.regime.display = opt !== undefined ? opt.value : "";
        } else {
            this.regimeMemoPourAide = this.dataForm.regime.vmodel;
        }

        this.changed();
    }

    /**
     * @description Applique la sélection du régime dans la liste
     * @param code Code du régime sélectionné
     */
    public onRegimeDecisionApply(code: string): void {
        if (this.listeMaladieRetraites.find((elt) => elt.Code === code)) {
            this.dataForm.regime.vmodel = code;
            this.regimeMemoPourAide = code;
            this.changed();
        } else {
            this.isManualChoice = true;
            NotificationServiceInstance.SendFailed("Nous n'avons pas trouvé de code correspondant au régime proposé, veuillez saisir manuellement votre régime ou réessayer.");
        }
    }

    private enregistrer() {
        this.formEntreeSalarie = <Form>this.$refs.formEntreeSalarie;
        this.formEntreeSalarie.trigger();

        setTimeout(() => {
            if (this.checkSuccessOrScroll()) {
                this.dataReady = false;

                this.setFormDataToEntreeSalarie();

                if (this.entreeSalarie !== undefined) {

                    if (this.entreeSalarie.Id === 0) { // Un Ajout
                        ServicesFactoryInstance.EntreeSalarieService.addEntreeSalarie(this.entreeSalarie, data => {
                            if (this.entreeSalarie !== undefined) {
                                this.entreeSalarie.Id = data.Id;
                                this.currentId = data.Id;
                            }

                            this.saveHoraireHebdo();
                            this.afterSend(true, true);
                        }, () => this.dataReady = true);
                    } else { // Une modification

                        ServicesFactoryInstance.EntreeSalarieService.updateEntreeSalarie(this.entreeSalarie, () => {
                            this.saveHoraireHebdo();
                            this.afterSend(false, true);
                        }, () => this.dataReady = true);
                    }
                }

            } else {
                NotificationServiceInstance.SendFailed("Des erreurs sont présentes dans le formulaire.");
            }

        }, 1);
    }

    /**
     * @description Vérifie si les horaires de présence sont valides et affiche une notification si ce n'est pas le cas
     * @returns true si les horaires de présence sont valides, false sinon
     */
    private isValidHorairesPresence(): boolean {
        const horairesErrors = this.validateHorairesPresence();
        if (horairesErrors.length > 0) {
            NotificationServiceInstance.SendFailedList(horairesErrors);
            return false;
        }

        return true;
    }

    private checkSuccessOrScroll() {
        if (this.formEntreeSalarie.checkSuccess() == false) {
            const errors = Object.values(this.formEntreeSalarie.dataForm).filter(d => d.required && d.error);

            if (errors.length === 1 && errors[0].label === 'Mode de règlement') {
                document.getElementById("modeReglementForm")?.scrollIntoView({ behavior: 'smooth' });
            }
            return false;
        }
        return true;
    }

    private soumettre() {
        this.formEntreeSalarie.trigger();
        this.refreshScroll();

        setTimeout(() => {
            if (this.checkSuccessOrScroll()) {
                this.submit();
            } else {
                NotificationServiceInstance.SendFailed("Des erreurs sont présentes dans le formulaire.");
            }
        }, 1);
    }

    private validateForm(): void {
        this.formEntreeSalarie.trigger();

        setTimeout(() => {
            if (this.checkSuccessOrScroll()) {

                const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
                    message: "Souhaitez-vous vraiment valider cette entrée ?",
                    callBackYes: () => {
                        if (this.entreeSalarie !== undefined) {
                            this.dataReady = false;

                            this.setFormDataToEntreeSalarie();

                            if (this.entreeSalarie !== undefined) {


                                if (this.entreeSalarie.Id === 0) { // Un Ajout
                                    ServicesFactoryInstance.EntreeSalarieService.addEntreeSalarie(this.entreeSalarie, data => {
                                        if (this.entreeSalarie !== undefined) {
                                            this.entreeSalarie.Id = data.Id;
                                            this.currentId = data.Id;
                                        }

                                        this.saveHoraireHebdo();
                                        this.validateEmploye();

                                    }, () => this.dataReady = true);
                                } else { // Une modification

                                    ServicesFactoryInstance.EntreeSalarieService.updateEntreeSalarie(this.entreeSalarie, () => {
                                        this.saveHoraireHebdo();

                                        this.validateEmploye();

                                    }, () => this.dataReady = true);
                                }

                            }
                        }
                    }
                });

                EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);

            } else {
                NotificationServiceInstance.SendFailed("Le formulaire n'a pas pu être validé. Veuillez renseigner tous les champs obligatoires.");
                this.dataReady = true;
            }

        }, 1);
    }

    // Permet de faire une copie d'un élément
    private copy(data): any {
        const copied = JSON.parse(JSON.stringify(data));
        return copied;
    }

    // Permet de nettoyer entreeSalarie
    private clearEntreeSalarie(): void {
        this.entreeSalarie = {
            Id: 0,
            DateNaissance: undefined,
            DateEntree: undefined,
            DateEntreeMetier: undefined,
            DateFinPrevisionnelleCDD: undefined,
            DateCreation: new Date(),
            DateModification: new Date(),
            NombreHeuresHebdomadaires: 0,
            SalaireBrutTotal: 0,
            SalaireBrutHoraire: 0,
            NombrePointsComplementaire: 0,
            ComplementSalaire: 0,
            EstValidee: false,
            EstSoumise: false,
            ModeReglement: 1,
            SalarieRemplace: "",
            ContratTravail: 0,
            DeclarationsEmbauches: 0,
            IdSalarieRemplace: 0,
            IbanCP: "",
            IbanCC: "",
            Bic: "",
            Titulaire: "",
            Domiciliation: "",
            NomBanque: ""
        };
    }

    private refreshScroll(): void {
        setTimeout(() => {
            this.scrollFormEntreeSalarie.refresh();
        }, 1);
    }

    private openModalTransfertAbsences(idSalarie: number, idNouveauContrat: number, titreOnglet: string) {

        ServicesFactoryInstance.SalarieService.getMostRecentContratTermine(idSalarie, undefined, mostRecentContrat => {
            if (mostRecentContrat.IdContrat == undefined || mostRecentContrat.DateFinContrat == undefined) {
                this.openFicheSalarie(idSalarie, titreOnglet);
                return;
            }

            let demandeRecuperation: DemandeRecuperationAbsencesFuturesDto = {
                IdContrat: mostRecentContrat.IdContrat,
                DateMax: mostRecentContrat.DateFinContrat
            };

            ServicesFactoryInstance.AbsencesService.getAbsencesFuturesByContrat(demandeRecuperation, data => {
                let demandeTransfert: DemandeTransfertAbsenceDto = {
                    IdAncienContrat: mostRecentContrat.IdContrat!,
                    IdNouveauContrat: idNouveauContrat
                };

                this.modalTransfertAbsencesFutures = this.$refs.modalTransfertAbsencesFutures as ModalTransfertAbsencesFutures;

                if (this.modalTransfertAbsencesFutures != undefined && data != undefined && data.length > 0) {

                    this.modalTransfertAbsencesFutures.continueProcess = () => {
                        this.openFicheSalarie(idSalarie, titreOnglet);
                    };

                    this.modalTransfertAbsencesFutures.init(data, demandeTransfert);
                } else {
                    this.openFicheSalarie(idSalarie, titreOnglet);
                }

            }, () => this.openFicheSalarie(idSalarie, titreOnglet))
        }, () => this.openFicheSalarie(idSalarie, titreOnglet));
    }

    private openFicheSalarie(idSalarie: number, titreOnglet: string): void {
        NotificationServiceInstance.SendSuccess("Entrée du salarié validée.");
        EventBus.$emit(EventConstants.CLOSE_TAB, { path: this.$router.currentRoute.path });

        EventBus.NavigateTo({
            path: "/ficheSalarie/" + idSalarie,
            query: { titre: titreOnglet }
        });
    }

    private toggleTypeMajoration(): void {
        if (Number(this.dataForm.heuresSupSemaine.vmodel) == 0 || !this.dataForm.heuresSupSemaine.vmodel) {
            this.dataForm.typeMajoration.disabled = true;
            this.dataForm.typeMajoration.vmodel = "";
        } else {
            this.dataForm.typeMajoration.disabled = this.readOnly;
        }
    }

    private calculHeureHebdoParMois(data: number): number {
        return Math.round(Number(data) * 5200 / 12) / 100;
    }

    private saveHoraireHebdo(): void {
        if (this.entreeSalarie === undefined || this.horaireHebdo === undefined || this.entreeSalarie.Id === 0) {
            return;
        }

        const entreeId = this.entreeSalarie.Id;

        ServicesFactoryInstance.HoraireHebdoService.addOrUpdateHoraireHebdoEntreeSalarie(this.entreeSalarie.Id, this.horaireHebdo, data => {
            if (this.entreeSalarie?.Id !== entreeId) {
                return;
            }
            NotificationServiceInstance.SendSuccess("Le calendrier du salarié a été enregistré");
            this.horaireHebdo = data ? normaliserHoraireHebdoRecu(data) : undefined;
            this.entreeSalarie!.IdHoraireHebdo = data ? data.Id : undefined;
            this.majAffichageHorairesPresence();
        }, () => {
            NotificationServiceInstance.SendFailed("L'enregistrement du calendrier a échoué");
        });
    }

    private afterSend(isAdd: boolean, showNotif: boolean): void {
        this.dataReady = true;

        this.disableBeforeRouteLeave = true;

        this.formEntreeSalarie = <Form>this.$refs.formEntreeSalarie;
        this.formEntreeSalarie.resetState();
        this.formEntreeSalarie.clear();

        if (showNotif) {
            if (isAdd) {
                NotificationServiceInstance.SendSuccess("Demande d'entrée de salarié créée avec succès.");
            } else {
                NotificationServiceInstance.SendSuccess("Modification de l'entrée du salarié effectuée avec succès.");
            }
        }

        EventBus.$emit(EventConstants.CLOSE_TAB, { path: this.$router.currentRoute.path });
        EventBus.NavigateTo({
            path: "/listeEntreeSalarie/"
        });
    }

    //Permet de désactiver un champ mais de quand même le prendre en compte lors de la vérification du formulaire
    private makeInputReaddOnly(input: InputOption) {
        input.disabled = true;
        input.checkEvenIfDisabled = true;
    }

    /**
     * @description Permet de définir si le formulaire est en lecture seule (readOnly) en fonction du rôle de l'utilisateur
     */
    private setReadOnly(): void {
        let readOnly: boolean = true;

        if (!this.entreeSalarie?.EstValidee) {
            if (ParametresInstance.userHasRole(RoleConstants.Administrateur)) {
                // L'Admin peut modifier si le formulaire n'est pas validé
                readOnly = false;
            } else if (ParametresInstance.userHasRole(RoleConstants.AdministrateurPST) && this.entreeSalarie?.EstSoumise) {
                // L'AdminPST peut modifier si le formulaire est soumis et pas validé
                readOnly = false;
            } else if (ParametresInstance.userHasRole(RoleConstants.UtilisateurPST) && !this.entreeSalarie?.EstSoumise) {
                // L'UtilisateurPST peut modifier si le formulaire n'est pas soumis et pas validé
                readOnly = false;
            }
        }

        this.readOnly = readOnly;
    }
}



// WEBPACK FOOTER //
// ./src/components/entreeSalarie/entreeSalarie.ts